import React from 'react';

import Typography from 'components-new/typography/typography';

type KanbanRowTitleProps = {
  title: string;
};
const KanbanColumnTitle: React.FC<KanbanRowTitleProps> = (props) => {
  return (
    <div className="flex flex-col items-center justify-center flex-grow mt-3 lg:mt-auto">
      <Typography variant="heading-5" as="span" className="text-gray400">
        {props.title}
      </Typography>
    </div>
  );
};
export default KanbanColumnTitle;
